import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createCategorySlice = createAsyncThunk(
    "category/createCategory",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/category/createCategory", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);
export const getCategorySlice = createAsyncThunk(
    "category/getCategory",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/category/getCategory", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const updateCategorySlice = createAsyncThunk(
    "category/updateCategory",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put("/category/updateCategory", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const deleteCategorySlice = createAsyncThunk(
    "category/deleteCategory",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put("/category/deleteCategory", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

const initialState = {
    categories: [],
    loading: false,
    createCategorySuccessMessage: null,
    createCategoryErrorMessage: null,
    updateCategorySuccessMessage: null,
    updateCategoryErrorMessage: null,
    deleteCategorySuccessMessage: null,
    deleteCategoryErrorMessage: null,
    searchCategoryErrorMessage: null
};
const categorySlice = createSlice({
    name: "category",
    initialState,
    reducers: {
        resetCreateCategoryMessage: (state) => {
            state.createCategorySuccessMessage = null;
            state.createCategoryErrorMessage = null;
        },
        resetUpdateCategoryMessage: (state) => {
            state.updateCategorySuccessMessage = null;
            state.updateCategoryErrorMessage = null;
        },
        resetDeleteCategoryMessage: (state) => {
            state.deleteCategorySuccessMessage = null;
            state.deleteCategoryErrorMessage = null;
        },
        resetSearchCategoryMeassage: (state) => {
            state.searchCategoryErrorMessage = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createCategorySlice.pending, (state) => {
                state.loading = true;
                state.createCategorySuccessMessage = null;
                state.createCategoryErrorMessage = null;
            })
            .addCase(createCategorySlice.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.createCategoryErrorMessage = action.payload.result.message;
                } else {
                    state.createCategorySuccessMessage = action.payload.result.message;
                }
            })
            .addCase(createCategorySlice.rejected, (state, action) => {
                state.loading = false;
                state.createCategoryErrorMessage = action.payload.result.message;
            })
            .addCase(getCategorySlice.pending, (state) => {
                state.loading = true;
            })
            .addCase(getCategorySlice.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.searchCategoryErrorMessage = action.payload.result.message
                }
                state.categories = action.payload.result.list
            })
            .addCase(getCategorySlice.rejected, (state, action) => {
                state.loading = false;
                state.searchCategoryErrorMessage = action.payload.result?.message
            })
            .addCase(updateCategorySlice.pending, (state) => {
                state.loading = true;
                state.updateCategorySuccessMessage = null;
                state.updateCategoryErrorMessage = null;
            })
            .addCase(updateCategorySlice.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.updateCategoryErrorMessage = action.payload.result.message;
                } else {
                    state.updateCategorySuccessMessage = action.payload.result.message;
                }
            })
            .addCase(updateCategorySlice.rejected, (state, action) => {
                state.loading = false;
                state.updateCategoryErrorMessage = action.payload.result.message;
            })
            .addCase(deleteCategorySlice.pending, (state) => {
                state.loading = true;
                state.deleteCategorySuccessMessage = null;
                state.deleteCategoryErrorMessage = null;
            })
            .addCase(deleteCategorySlice.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.deleteCategoryErrorMessage = action.payload.result.message;
                } else {
                    state.deleteCategorySuccessMessage = action.payload.result.message;
                }
            })
            .addCase(deleteCategorySlice.rejected, (state, action) => {
                state.loading = false;
                state.deleteCategoryErrorMessage = action.payload.result.message;
            })
    }
});
export const { resetCreateCategoryMessage, resetUpdateCategoryMessage, resetDeleteCategoryMessage, resetSearchCategoryMeassage } = categorySlice.actions;

export default categorySlice.reducer;
